/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRoutineRequest } from '../../models/create-routine-request';
import { Routine } from '../../models/routine';

export interface CreateRoutine$Params {
      body: CreateRoutineRequest
}

export function createRoutine(http: HttpClient, rootUrl: string, params: CreateRoutine$Params, context?: HttpContext): Observable<StrictHttpResponse<Routine>> {
  const rb = new RequestBuilder(rootUrl, createRoutine.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Routine>;
    })
  );
}

createRoutine.PATH = '/routines';
